export const enum CheckIds {
    Banniere = "maggrp_cd",
    Magasin = "mag_num",
    Division = "div_num",
    Section = "plans_nom",
    Fournisseur = "four_cd",
    Statut = "statut_aff",
    Activite = "act_cd",
    Acheteur = "usr_cd",
    Collections = "prod_collection"
};